import {useEffect} from "react";

export const onInputBlur = (event, property, setInputValue, errorsObject, changeErrorsObject, getValidationErrors) => {
  const value = (event && event.target && event.target.value ? event.target.value : "").trim();
  setInputValue(property, value); // set trimmed version
  if (changeErrorsObject && getValidationErrors) {
    const errors = getValidationErrors(property, value);
    if (errors.length) {
      changeErrorsObject({
        [property]: errors
      })
    } else if (!errors.length && errorsObject && errorsObject[property]) {
      changeErrorsObject({
        [property]: errors
      })
    }
  }
}

export const onInputChange = (event, property, setInputValue, errorsObject, changeErrorsObject, getValidationErrors) => {
  const value = event.target.value;
  setInputValue(property, value);
  if (errorsObject && errorsObject[property] && getValidationErrors) {
    const errors = getValidationErrors(property, value);
    if (!errors.length && changeErrorsObject) {
      changeErrorsObject({
        [property]: errors
      })
    }
  }
};

export const useInputsValidation = (inputsValidated, onBlur, inputValue) => {
  useEffect(() => {
    if (!inputsValidated) {
      onBlur({
        target: {
          value: inputValue
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsValidated]);
};
